export const createId = string => string.replace(/[^\x20-\x7E]/g, '').replace(/ /g, '').replace(/\(/g, '').replace(/\)/g, '').replace(/'/g, '').toLowerCase();

export const generateId = () => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < 10) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }
    return result;
};